export default { sha: 'c47d9ff32eef5cc39ee82f0d492cf96c5b747ebe', buildNumber: 'undefined' }
